module.exports = __webpack_public_path__ + "static/media/metal_tink.f848850d.ogg";